'use client';

import { BuilderPage } from '@/components/builder';
import StructuredDataSchema from '@/components/StructuredDataSchema';
import { webApplicationSchema } from '@/lib/schemas';

export default function BuilderRoute() {
  return (
    <>
      {/* Organization + WebSite are injected globally in app/layout.tsx */}
      <StructuredDataSchema schema={webApplicationSchema} schemaId="webapplication-schema" />
      <BuilderPage />
    </>
  );
}
